var map = {
	"./advertising.svg": "6974",
	"./captcha.svg": "08e8",
	"./cog-fill.svg": "78c1",
	"./menu.svg": "bd3d",
	"./multi-file.svg": "6434",
	"./password.svg": "2a3d",
	"./single-file.svg": "778c",
	"./swiper.svg": "54e9",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";